import { FormEvent, useState } from 'react'

/**
 * Asks for the second secret before a destructive action.
 *
 * Not a lock on the panel itself, the caller already proved they are the
 * system administrator to get here. This is the second factor for the one
 * kind of action that is hard to undo: opening a login with full ownership
 * of an institution. See functions/admin/index.ts for where the value is
 * actually checked; nothing here validates it, the secret is only carried
 * to the caller.
 */
export function PanelGate({
  title,
  onConfirm,
  onCancel,
}: {
  title: string
  onConfirm: (secret: string) => void
  onCancel: () => void
}) {
  const [secret, setSecret] = useState('')

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (!secret) return
    onConfirm(secret)
  }

  return (
    <div className="panel-gate__backdrop" role="dialog" aria-modal="true">
      <form className="panel-gate" onSubmit={onSubmit}>
        <h2>{title}</h2>
        <p>Bu işlem geri alınamaz. Devam etmek için ikinci şifreyi girin.</p>
        <input
          type="password"
          value={secret}
          onChange={(e) => setSecret(e.target.value)}
          placeholder="İkinci şifre"
          autoComplete="off"
        />
        <div className="panel-gate__actions">
          <button type="button" className="btn btn--outline" onClick={onCancel}>
            Vazgeç
          </button>
          <button type="submit" className="btn btn--primary" disabled={!secret}>
            Onayla
          </button>
        </div>
      </form>
    </div>
  )
}
